import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const GraficoRecurrenciaClientes = ({ datos }) => {
  const [agrupado, setAgrupado] = useState({});

  useEffect(() => {
    const frecuencia = {};

    datos.forEach(d => {
      const razon = d.razon_social;
      if (!frecuencia[razon]) frecuencia[razon] = 0;
      frecuencia[razon]++;
    });

    const resumen = {
      "1 vez": 0,
      "2-4 veces": 0,
      "5-9 veces": 0,
      "10-19 veces": 0,
      "20+ veces": 0
    };

    Object.values(frecuencia).forEach(cantidad => {
      if (cantidad === 1) resumen["1 vez"]++;
      else if (cantidad >= 2 && cantidad <= 4) resumen["2-4 veces"]++;
      else if (cantidad >= 5 && cantidad <= 9) resumen["5-9 veces"]++;
      else if (cantidad >= 10 && cantidad <= 19) resumen["10-19 veces"]++;
      else resumen["20+ veces"]++;
    });

    setAgrupado(resumen);
  }, [datos]);

  const labels = Object.keys(agrupado);
  const values = Object.values(agrupado);
  const totalClientes = values.reduce((a, b) => a + b, 0);
  const porcentajes = values.map(v => ((v / totalClientes) * 100).toFixed(1));

  const chartData = {
    labels: labels.map((l, i) => `${l} (${porcentajes[i]}%)`),
    datasets: [
      {
        data: values,
        backgroundColor: [
          "#A1C298", "#FFD56B", "#FF6B6B", "#6A67CE", "#3AB0FF"
        ]
      }
    ]
  };

  return (
    <div className="mt-5" style={{ height: "450px", maxWidth: "800px", margin: "0 auto" }}>
      <h5 className="text-center mb-3">Recurrencia de Clientes</h5>
      <Doughnut data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
    </div>
  );
};

export default GraficoRecurrenciaClientes;
